// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"186":"adbf8df577af0df1","888":"7bdc278fb39bbfd1"}[chunkId] + ".css";
};